import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../../shared/http/http-data.service';

import { ITicket } from '../../../../shared/ticket/ticket-data.service';

export enum TicketStatus {
  OPEN = 'Open',
  CLOSED = 'Closed',
  ALL = 'All'
}

interface ITicketFilterOption {
  id?:string;
  label?:string;
}

export interface IBPTicketResponse {
  currentPage?:number;
  numberOfPages?:number;
  totalData?:number;
  page?: {
    newLink?:string;
    tickets?:ITicket[];
  }
}

@Injectable()
export class BPProfilesTicketsDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public getFilterOptions():ITicketFilterOption[] {
    return [
      {
        id: TicketStatus.OPEN,
        label: 'BPPROFILES.TICKETS.FILTERS.OPEN'
      },
      {
        id: TicketStatus.CLOSED,
        label: 'BPPROFILES.TICKETS.FILTERS.CLOSED'
      },
      {
        id: TicketStatus.ALL,
        label: 'BPPROFILES.TICKETS.FILTERS.ALL'
      }
    ];
  }

  public getBPTickets(profileId:number, status?:string, page?:number):Promise<IBPTicketResponse> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/tickets`,
      { status, page },
      undefined,
      'Error getting BP Tickets'
    );
  }
}